export const INITIAL_USERS_REQUEST = "INITIAL_USERS_REQUEST";
export const FETCH_USERS_SUCCESS = "FETCH_USERS_SUCCESS";
export const FINAL_USERS_REQUEST = "FINAL_USERS_REQUEST";
